import { Link } from "react-router";
import { useTabs } from "../../lib/useTabs.js";
import LoopVideo from "../LoopVideo/LoopVideo.jsx";
import styles from "./ProductTabs.module.css";

/**
 * The two products as one tabbed stage: a looping clip of the product at work beside what
 * it does for the people buying it. Replaces two side-by-side panels that read like
 * brochure pages.
 */
export default function ProductTabs({ products, label = "Products" }) {
  const { active, tabProps, panelProps } = useTabs(products.length);
  return (
    <div className={styles.root}>
      <div className={`segmented ${styles.tabs}`} role="tablist" aria-label={label}>
        {products.map((p, i) => (
          <button key={p.key} {...tabProps(i)}>
            {p.name}
          </button>
        ))}
      </div>
      {products.map((p, i) => (
        <div key={p.key} {...panelProps(i)} className={styles.panel}>
          <LoopVideo
            src={p.video}
            poster={p.poster}
            caption={p.caption}
            focus={p.focus}
            open={i === active}
          />
          <div className={styles.text}>
            <h3 className={styles.title}>{p.title}</h3>
            <p className={styles.lead}>{p.text}</p>
            <ul className={styles.points}>
              {p.points.map((point) => (
                <li key={point}>{point}</li>
              ))}
            </ul>
            <Link to={p.href} className={`btn btn-secondary ${styles.cta}`}>
              {p.cta}
            </Link>
          </div>
        </div>
      ))}
    </div>
  );
}
